<template>
    <div class="mr-3">
        <button type="button" :class="['btn btnclass smallerfontsize', addSelectedClass]" @click="fieldData.showFilmCodeModal = true">
            Film codes
        </button>
        <b-modal id="modal-codes" title="Select film codes" size="xl" @ok="saveFilmCodes" @hide="onHidden" @show="showModal" :no-close-on-backdrop="true" v-model="fieldData.showFilmCodeModal">
            <div class="row align-items-start">
                <div class="col-sm-8 pabBorder">
                    <label>Agency</label>
                    <div class="input-group mb-3">
                        <v-select class="vueSelect" :options="fieldData.buyingAgencies" v-model="selectedBuyingAgency">
                            <span slot="no-options">No search results.</span>
                        </v-select>
                    </div>

                    <div class="input-group mb-3">
                        <label>Advertiser</label>
                        <div class="input-group">
                            <v-select class="vueSelect" :options="fieldData.advertisers" v-model="selectedAdvertiser">
                                <span slot="no-options">No search results.</span>
                            </v-select>
                        </div>
                    </div>
                    <div class="input-group">
                        <label>Product</label>
                        <div class="input-group mb-3">
                            <v-select class="vueSelect" :options="fieldData.products" v-model="selectedProduct">
                                <span slot="no-options">No search results.</span>
                            </v-select>
                        </div>
                        <div class="col-sm-12 px-0 mb-3">
                            <b-button variant="primary" size="sm" @click="filmCodeSearch()">
                                Search film codes
                            </b-button>
                        </div>
                        <div v-if="filmCodeList.length > 0" class="col-sm-2 px-0">
                            <b-button variant="success" size="sm" @click="saveCodesFromTable()">
                                Add all
                            </b-button>
                        </div>
                        <div v-else-if="statusfilmcodes == 'notchosen_selectlists'" class="col-sm-6 mt-2 text-center">
                            Please select agency, advertiser or product
                        </div>
                        <div v-else-if="statusfilmcodes == 'empty_search'" class="col-sm-6 mt-2 text-center">
                            no results
                        </div>
                        <div class="col-sm-10 px-0 d-flex align-items-center">
                            <span :style="cssVars" :class="{ filmcodeslengthcount: filmCodeList.length > 0 }"></span>
                            <span class="ml-1" v-if="filmCodeList.length > 0">Rows</span>
                        </div>
                    </div>
                    <div class="filmCodeTableWrapper" v-show="filmCodeList.length > 0">
                        <table class="table table-hover filmCodeTable table-sm">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Film code</th>
                                    <th scope="col">Agency</th>
                                    <th scope="col">Advertiser</th>
                                    <th scope="col">Product</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(film, index) in filmCodeList" :key="index">
                                    <th>
                                        <b-button class="text-nowrap" size="sm" variant="success" @click="saveCodeFromTable(film.copyCode)">
                                            Add
                                        </b-button>
                                    </th>
                                    <td>{{ film.copyCode }}</td>
                                    <td>{{ film.buyingAgency }}</td>
                                    <td>{{ film.advertiser }}</td>
                                    <td>{{ film.productName }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="col-sm-12">
                        <label>Film code</label>
                        <b-form-textarea v-model="value" :placeholder="'Enter film code(s)'" :rows="1" :max-rows="8"> </b-form-textarea>
                    </div>
                    <div class="col-sm-12 mb-3">
                        <b-button class="mt-2 mr-2" size="sm" variant="success" @click="saveCode">
                            Add
                        </b-button>
                        <b-button v-if="filmCodes.length > 1" variant="danger" size="sm" class="mt-2" @click="removeCodes()">
                            Remove all
                        </b-button>
                    </div>
                    <div class="selectedfilmcodesclass">
                        <div class="col-sm-12" v-for="(item, index) in filmCodes" :key="'code_' + index">
                            <div class="form-row mt-2">
                                <div class="col-sm-9">
                                    {{ item }}
                                </div>
                                <div class="col-sm-3 text-right">
                                    <b-button variant="danger" size="sm" @click="removeCode(index)">
                                        Remove
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm" variant="primary" @click="ok()">
                    Save
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import "vue-select/dist/vue-select.css"
import props from "@/mixins/inputProps"
import vSelect from "vue-select"
import { getFilmCodes } from "../../../../api/api.js"

export default {
    name: "FilmcodePicker",
    mixins: [props],
    components: {
        vSelect,
    },
    data() {
        return {
            selectedFilmCodesBeforeChange: [],
            statusfilmcodes: "no_search",
            value: "",
            buttonText: "Film codes",
            buyingAgencies: [],
            products: [],
            selectedBuyingAgency: "",
            selectedAdvertiser: "",
            selectedProduct: "",
            filmCodeList: [],
        }
    },
    watch: {
        "fieldData.advertisers": function(newAdvertisers) {
            if (newAdvertisers && this.selectedAdvertiser && !newAdvertisers.some(advertiser => advertiser.id === this.selectedAdvertiser.id)) {
                this.selectedAdvertiser = null
            }
        },
        "fieldData.products": function(newProducts) {
            if (newProducts && this.selectedProduct && !newProducts.some(product => product.id === this.selectedProduct.id)) {
                this.selectedProduct = null
            }
        },
        "fieldData.buyingAgencies": function(newBuyingAgencies) {
            if (newBuyingAgencies && this.selectedBuyingAgency && !newBuyingAgencies.some(buyingAgency => buyingAgency.id === this.selectedBuyingAgency.id)) {
                this.selectedBuyingAgency = null
            }
        },
    },
    computed: {
        cssVars() {
            return {
                "--filmCodes-length": this.filmCodeList.length,
            }
        },
        filmCodes() {
            this.setButtonText()
            return this.$store.getters[this.getter]?.[this.fieldData.identifier] ? this.$store.getters[this.getter][this.fieldData.identifier] : []
        },
        addSelectedClass() {
            let adThisClass = ""
            if (this.filmCodes.length > 0) adThisClass = "selected"
            return adThisClass
        },
    },
    methods: {
        showModal() {
            document.addEventListener("keyup", this.onKeyUp)
            this.selectedFilmCodesBeforeChange = this.$store.getters[this.getter][this.fieldData.identifier]
        },
        onKeyUp(event) {
            if (event.key === "Enter" && this.fieldData.showFilmCodeModal) {
                this.fieldData.showFilmCodeModal = false
            }
        },
        onHidden(e) {
            if (e.trigger == "cancel" || e.trigger == "headerclose") {
                const updatedQuery = {
                    ...this.$store.getters[this.getter],
                    [this.fieldData.identifier]: this.selectedFilmCodesBeforeChange,
                }
                this.$store.commit(this.setter, updatedQuery)
            }
        },
        async filmCodeSearch() {
            this.filmCodeList = []

            if (!this.selectedAdvertiser && !this.selectedBuyingAgency && !this.selectedProduct) {
                this.statusfilmcodes = "notchosen_selectlists"
                return
            }
            let startDate = this.$store.getters.getAdsQuery.startDate
            let endDate = this.$store.getters.getAdsQuery.endDate

            if (!startDate) startDate = null
            if (!endDate) startDate = null

            await getFilmCodes({
                Advertiser: this.selectedAdvertiser?.id ?? "",
                ProductName: this.selectedProduct?.id ?? "",
                BuyingAgency: this.selectedBuyingAgency?.id ?? "",
                StartDate: startDate,
                EndDate: endDate,
            })
                .then(filmcodes => {
                    this.statusfilmcodes = filmcodes.length == 0 ? "empty_search" : "not_empty_search"
                    this.filmCodeList = filmcodes
                })
                .catch(error => {
                    this.toastMessage("Problem loading film codes. The service may have issues.")
                    console.error(error)
                })
        },
        toastMessage(message) {
            this.$bvToast.toast(message, {
                title: "Varning",
                variant: "warning",
                solid: true,
                autoHideDelay: 3000,
            })
        },
        setPreviousMonthFromToday() {
            var d = new Date()
            var newMonth = d.getMonth() - 1
            if (newMonth < 0) {
                newMonth += 12
                d.setYear(d.getFullYear() - 1) // use getFullYear instead of getYear !
            }
            d.setMonth(newMonth)
            return d
        },
        saveCode() {
            this.saveCodeFromTable(this.value)
        },
        saveCodeFromTable(filmcode) {
            if (filmcode.length === 0) return
            let filmCodeArray = filmcode.split(/[\s,]+/)

            filmCodeArray = filmCodeArray.filter(n => n.length > 0)

            const updatedCodes = [...this.filmCodes]
            for (let ip = 0; ip < filmCodeArray.length; ip++) {
                let filmCodeInput = filmCodeArray[ip].toUpperCase()
                if (updatedCodes.includes(filmCodeInput)) {
                    this.$bvToast.toast(`Film code ${filmCodeInput} already exists.`, {
                        title: "Varning",
                        variant: "warning",
                        solid: true,
                        autoHideDelay: 3000,
                    })
                    return
                }
            }

            filmCodeArray.forEach(element => updatedCodes.push(element.toUpperCase()))

            const updatedQuery = {
                ...this.$store.getters[this.getter],
                [this.fieldData.identifier]: updatedCodes,
            }
            this.value = ""
            this.$store.commit(this.setter, updatedQuery)
        },
        saveCodesFromTable() {
            let allFilmcodes = this.filmCodeList.map(element => {
                return element.copyCode
            })
            const updatedQuery = {
                ...this.$store.getters[this.getter],
                [this.fieldData.identifier]: allFilmcodes,
            }
            this.$store.commit(this.setter, updatedQuery)
        },

        removeCode(index) {
            const updatedCodes = [...this.filmCodes]
            updatedCodes.splice(index, 1)

            const updatedQuery = {
                ...this.$store.getters[this.getter],
                [this.fieldData.identifier]: updatedCodes,
            }

            this.$store.commit(this.setter, updatedQuery)
        },
        removeCodes() {
            const updatedQuery = {
                ...this.$store.getters[this.getter],
                [this.fieldData.identifier]: [],
            }

            this.$store.commit(this.setter, updatedQuery)
        },
        setButtonText() {
            let filmCodes = this.$store.getters[this.getter]?.[this.fieldData.identifier]
            this.buttonText = filmCodes.length == 1 ? `Film codes (${filmCodes.length} selected)` : `Film codes (${filmCodes.length} selected)`
        },
        saveFilmCodes() {
            let selectedFilmCodes = this.$store.getters[this.getter][this.fieldData.identifier]
            const updatedQuery = {
                ...this.$store.getters[this.getter],
                [this.fieldData.identifier]: selectedFilmCodes,
            }
            this.$store.commit(this.setter, updatedQuery)
        },
    },
}
</script>

<style scoped>
label {
    width: 100%;
}

.vueSelect {
    width: 60%;
}

.pabBorder {
    border-right: 1px solid black;
}
.filmCodeTableWrapper {
    height: 500px;
    overflow-x: hidden;
}
.filmCodeTable {
    margin-top: 15px;
}
.selectedfilmcodesclass {
    max-height: 703px;
    overflow: auto;
}
tbody {
    display: block;
    height: 432px;
    overflow-x: hidden;
}
thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}
thead {
    width: calc(100% - 1em);
}
@property --num {
    syntax: "<integer>";
    initial-value: 0;
    inherits: false;
}
.filmcodeslengthcount {
    transition: --num 2s;
    counter-set: num var(--num);
    display: table-cell;
    vertical-align: middle;
}
.filmcodeslengthcount::after {
    content: counter(num);
}
.filmcodeslengthcount {
    --num: var(--filmCodes-length);
}
</style>
